<div class="reporting-stations-dashboard">
  <sc-flex vertical stretchContent fitHeight>

    <div class="menu widget-menu-layer-1">
      <span class="item" (click)="back()"><sc-icon iconClass="fa-chevron-left"></sc-icon></span>
      <span class="item">{{selectedDate | date: 'dd.MM.yyyy'}}</span>
      <span class="item" (click)="forward()"><sc-icon iconClass="fa-chevron-right"></sc-icon></span>
      <span class="item margin-left-25" [ngClass]="{'selected': isShowDailyMode()}" (click)="showDailyMode()">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.station-occupancy.mode.daily"></sc-dictionary-label>
      </span>
      <span class="item" [ngClass]="{'selected': isShowHourlyMode()}" (click)="showHourlyMode()">
        <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.station-occupancy.mode.hourly"></sc-dictionary-label>
      </span>
      @if (isShowHourlyMode()) {
        <button class="item margin-left-25" mat-stroked-button (click)="printHourlyReport()">
          <sc-dictionary-label dictionaryKey="tmc-yard.ui.reporting.station-occupancy.action.print-hourly"></sc-dictionary-label>
        </button>
      }
    </div>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-flex-fitting-content vertical>
      @if (isShowDailyMode() && data != null) {
        <app-stacked-bar-chart [data]="data.chart"></app-stacked-bar-chart>
      }
      @if (isShowHourlyMode() && data != null && this.data.chartSvg) {
        <sc-padding fitHeight>
          @if (isShowHourlyMode()) {
            <div class="svg-chart" [innerHtml]="this.data.chartSvg | trustHtml"></div>
          }
        </sc-padding>
      }
    </sc-flex-fitting-content>

  </sc-flex>

</div>
